export default __webpack_public_path__ + "static/media/top-image.12bc1f4b.jpg";